import {
  LIVE_TRACKER_ANALYTICS_DATA_LOADED,
  LIVE_TRACKER_ANALYTICS_DATA_CLEAR,
  WATERMARK_DETECTIONS_LOADED,
  WATERMARK_DETECTIONS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  liveTrackerData: null,
  watermarkDetections: null,
};

function analytics(state = initialState, action) {
  switch (action.type) {
    case LIVE_TRACKER_ANALYTICS_DATA_LOADED:
      return {
        ...state,
        liveTrackerData: action.payload.analyticsData,
      };
    case LIVE_TRACKER_ANALYTICS_DATA_CLEAR:
      return {
        ...state,
        liveTrackerData: null,
      };
    case WATERMARK_DETECTIONS_LOADED:
      return {
        ...state,
        watermarkDetections: action.payload.data,
      };
    case WATERMARK_DETECTIONS_CLEAR:
      return {
        ...state,
        watermarkDetections: null,
      };
    default:
      return state;
  }
}

export default analytics;
